// extracted by mini-css-extract-plugin
export default {"glossaryPage":"glossaryPage--3ENZ7"};